import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Loading from './component'
import { toggleLoading } from 'Actions'

class LoadingContainer extends Component {
  static propTypes = {
    toggleLoading: PropTypes.func
  }

  componentDidMount() {
    this.props.toggleLoading()
  }

  componentWillUnmount() {
    this.props.toggleLoading()
  }

  render() {
    return <Loading />
  }
}

const mapDispatchToProps = dispatch => ({
  toggleLoading: bindActionCreators(toggleLoading, dispatch),
  dispatch
})

export default connect(null, mapDispatchToProps)(LoadingContainer)
